import { IDictionaryValue } from 'APIPackage/DictionariesModule/interfaces/IDictionaryValue';
import { IKnmErvk } from 'APIPackage/CatalogsModule/interfaces/IKnmErvk';

import { DictionaryUUIDsEnum } from '../enums/DictionaryUUIDsEnum';
import { makeCreateDictionarySelectOption } from './makeCreateDictionarySelectOption';

export const createDictionaryErvkSelectOption = makeCreateDictionarySelectOption<IKnmErvk>('id', 'title');

export const createDictionarySupervisionTypeExtendedSelectOption = (
  dictionaryId: DictionaryUUIDsEnum,
  dictionaryValue: IDictionaryValue<IKnmErvk>,
) => {
  const option = makeCreateDictionarySelectOption<IKnmErvk>('id', 'title')(dictionaryId, dictionaryValue);

  return {
    ...option,
    label: option.title,
  };
};
